import React, { Component } from 'react';
import '../App.css';
import { Panel, Row, Col, Grid } from 'react-bootstrap';
import Ebay from '../Engines/Ebay.js';
import AppStore from '../Engines/AppStore.js';
import PlayStore from '../Engines/PlayStore.js';
import Description from './Description.js';

const engines = new Map();

//Description of this group.
//This is what user will see by pressing the info icon.
const description = (
  <div>
    Ebay, App Store and Play Store list search results with
    your query from the given marketplaces.
  </div>
)

class Stores extends Component {
  constructor () {
    super();
    engines.set("Ebay", {});
    engines.set("App Store", {});
    // engines.set("Play Store", {});
    this.state = {
      resultCount: 0,
      open: true,
      noSearches: true
    };
  }

  clear(){
    engines.set("Ebay", {});
    engines.set("App Store", {});
    // engines.set("Play Store", {});
    this.setState({
      resultCount: 0,
      open: true,
    });
  }

  addResult(source, content, searchQuery) {
    if (engines.has(source)) {
      engines.set(source, content)
      this.setState({
        resultCount: this.state.resultCount + 1,
        noSearches: false
      });
    }
  }

  handleClick() {
    this.setState({open: !this.state.open});
  }

  header(){
    return(
      <div className="resultBox__header" onClick={ ()=> this.setState({ open: !this.state.open })}>
        <h3 className="resultBox__title">Stores</h3>
      </div>
    );
  }

  render() {
      return (
        <Panel className="resultBox" collapsible expanded={this.state.open} header={this.header()}>
          <div className="resultBox__content clearfix">

            <Grid fluid>
              <Row>
                <Col sm={12}>
                  <Ebay content={engines.get("Ebay")}/>
                </Col>
              </Row>
              <Row>
                <Col sm={12}>
                  <AppStore content={engines.get("App Store")}/>
                </Col>
                {/* <Col sm={6}>
                  <PlayStore content={engines.get("Play Store")}/>
                </Col> */}
              </Row>
            </Grid>

          </div>
          <div className="resultBox__footer">

            <div className="resultBox__help">
              <Description description={description}/>
              <p>What is this report about?</p>
            </div>

          </div>
        </Panel>
      );
  }
}

export default Stores;



// WEBPACK FOOTER //
// ./client/src/Groups/Stores.js